import { Directive, Input, Output, HostListener, EventEmitter } from '@angular/core'

import { ShareProvider } from '../shared/share-provider.enum'
import { ShareArgs } from '../shared/share-args'
import { ShareService } from '../shared/share/share.service'

@Directive({
  selector: '[cmShareButton]'
})
export class ShareButtonDirective {

  private provider: ShareProvider

  @Input() url: string
  @Input() title: string
  @Input() image: string

  @Output() popUpClose = new EventEmitter<ShareProvider>()

  constructor(private shareService: ShareService) { }

  @Input() set cmShareButton(provider: ShareProvider) {
    this.provider = provider
  }

  @HostListener('click') onClick() {
    this.share()
  }

  share() {
    const args = new ShareArgs(this.url, this.title, this.image)
    this.shareService.share(this.provider, args, this.popUpClose)
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/social-share/share-button/share-button.directive.ts